var map = {
	"./arrow-down.svg": "5c3c",
	"./arrow-up.svg": "5200",
	"./blue-fire.svg": "e653",
	"./case-2.svg": "0191",
	"./case-3.svg": "f88d",
	"./case.svg": "57dd",
	"./checked.svg": "8ab9",
	"./clean.svg": "a2c6",
	"./contracts.svg": "f849",
	"./contractsThin.svg": "80ce",
	"./dropdown-arrows.svg": "2667",
	"./email.svg": "a96b",
	"./help.svg": "89a5",
	"./improve.svg": "5b98",
	"./item-minus-2.svg": "943c",
	"./item-plus-2.svg": "9e03",
	"./live-bar-gift.svg": "1c0e",
	"./live-bar-live.svg": "efae",
	"./live-bar-top.svg": "002e",
	"./logout.svg": "24fc",
	"./mana.svg": "d53a",
	"./mob-menu-wa.svg": "a673",
	"./new.svg": "9429",
	"./plus.svg": "8c7a",
	"./profile.svg": "2569",
	"./promotions.svg": "30be",
	"./promotionsThin.svg": "52c8",
	"./repeat.svg": "9ec7",
	"./runeEvent.svg": "4bc3",
	"./steam.svg": "1ae5",
	"./take.svg": "2a31",
	"./tasks.svg": "1de5",
	"./telegram.svg": "9dae",
	"./upgradeThin.svg": "7870",
	"./upgrades-2.svg": "6979",
	"./upgrades.svg": "1434",
	"./vkontakte.svg": "3b5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";